export default __webpack_public_path__ + "static/media/player-leah-colour-mob@2x.a4b1a42b.png";